module.exports = __webpack_public_path__ + "img/home-bg.e6246d0f.png";